import { Controller } from '@hotwired/stimulus'
import {
  preferredCodeLanguage,
  setPreferredCodeLanguage
} from '../code_editor_language.js'

export default class extends Controller {
  static targets = ['panel']
  static outlets = ['code-select', 'custom-select']

  customSelectOutletConnected(outlet) {
    const language = preferredCodeLanguage(this.#outletOptionValues(outlet))
    if (!language) return

    const hasOption = outlet.optionTargets.some(
      o => o.dataset.value === language
    )

    if (!hasOption) return

    outlet.activate(language, false)
    this.#switchPanel(language)
  }

  handleChange(event) {
    const { value } = event.detail
    setPreferredCodeLanguage(value, this.#selectableLanguages())
    this.#switchPanel(value)
    this.#broadcast(value)
  }

  sync(value) {
    this.#switchPanel(value)
    this.customSelectOutlets.forEach(outlet => {
      if (this.#outletHasOption(outlet, value)) outlet.activate(value, false)
    })
  }

  #broadcast(value) {
    this.codeSelectOutlets.forEach(outlet => outlet.sync(value))
  }

  #switchPanel(value) {
    if (!this.hasPanelTarget) return

    const hasMatch = this.panelTargets.some(p => p.dataset.languageId === value)

    if (!hasMatch) return

    this.panelTargets.forEach(panel => {
      panel.dataset.active = (panel.dataset.languageId === value).toString()
    })
  }

  #outletHasOption(outlet, value) {
    return this.#outletOptionValues(outlet).includes(value)
  }

  #outletOptionValues(outlet) {
    return outlet.optionTargets.map(option => option.dataset.value)
  }

  #selectableLanguages() {
    return [
      ...this.panelTargets.map(panel => panel.dataset.languageId),
      ...this.customSelectOutlets.flatMap(outlet =>
        this.#outletOptionValues(outlet)
      )
    ]
  }
}
